import React, { useMemo } from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseInput from "../../components/BaseInput";
import { useTranslation } from "react-i18next";
import Game from "../../store/Game";
import buildInviteLink from "../../utils/buildInviteLink";
import "./style.scss";
import { observer } from "mobx-react-lite";
import useMutateCopyData from "../../hooks/useMutateCopyData";
import { copyText2, copyText3 } from "../../utils/constants";

// Содержимое окна: монтируется только пока окно открыто (BaseModal рендерит
// children лишь при isOpen). 10.10: окно стало глобальным (RootModals), а подмена
// буфера (useMutateCopyData) висела на документе, пока смонтирован компонент, — т.е.
// на всех страницах любое копирование заменялось текстом приглашения. Теперь
// подмена живёт только внутри открытого окна.
const LinkWasNotSentContent = observer(function LinkWasNotSentContent() {
  const { t } = useTranslation();

  // Ссылка — реактивно из Game.game
  const link = useMemo(() => {
    const gameLink = Game.game?.link?.link;
    return gameLink ? buildInviteLink(gameLink) : "";
  }, [Game.game?.link?.link]);

  // Копирование (кнопка — через ClipboardJS — и Ctrl+C) дописывает текст приглашения
  useMutateCopyData(link, Game.game?.type === "DEMO" ? copyText3 : copyText2);

  return (
    <div className="link-was-not-sent-modal__content">
      <div className="link-was-not-sent-modal__description">
        {t("linkWasNotSent.description")}
      </div>
      <BaseInput
        id={`input-clipboard-target-link-was-not-sent-modal`}
        name="link-was-not-sent"
        className="link-was-not-sent-modal__input"
        value={link}
        type="copy"
        wrapperStyle="link-was-not-sent-modal__input-wrapper"
        // раньше здесь на каждый клик добавлялся ещё один document-слушатель copy
        // (без снятия) — копирование оставалось подменённым навсегда
        copyOnClick={link ? () => {} : undefined}
      />
    </div>
  );
});

// Модалка использует тот же визуальный контент, что и страница LinkWasNotSentPage,
// но не тянет её контроллер: все данные берём напрямую из стора/конфига.
export default function LinkWasNotSentModal() {
  return (
    <BaseModal
      className="link-was-not-sent-modal"
      eventTypeModal={MODAL_TYPES.LINK_WAS_NOT_SENT}
    >
      <LinkWasNotSentContent />
    </BaseModal>
  );
}
